import { SetIsPostDispatchI } from './action'
export enum UtilActionsTypes {
	setIsPost,
}

export type UtilAction = SetIsPostDispatchI
